import { useState, useEffect } from 'react';
import ApiUser from '../services/usuarioService'
import Swal from 'sweetalert2';

export default function useAuth() {
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && token.length > 0) {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  async function handleLogin(email, password, navigate) {
    const res = await ApiUser.login(email, password);
    if (res.error) {
      Swal.fire({
        text: 'Usuário ou senha inválidos',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    } else {
      const me = await ApiUser.me(res.access_token);
      if (me.active==='yes') {
        if (me.role === 'aluno') {
          Swal.fire({
            text: 'Tudo pronto! Vamos começar?',
            icon: 'success',
            confirmButtonText: 'Ok',
          });
          localStorage.setItem('token', res.access_token);
          localStorage.setItem('user', JSON.stringify(me));
          setAuthenticated(true);
          setUser(me);
          navigate('/');
        } else {
          Swal.fire({
            text: 'Acesso inválido, por favor entre em contato conosco através do formulário de contato!',
            icon: 'error',
            confirmButtonText: 'Ok',
          });
          setAuthenticated(false);
        }
        
      } else {
        Swal.fire({
          text: 'Usuário ou senha inválidos!',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
        setAuthenticated(false);
      }
    }
  }

  function handleLogout() {
    setAuthenticated(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  return { authenticated, loading, handleLogin, handleLogout, user };
}
